/* eslint-disable import/extensions */
import React, { useEffect, useState } from "react";
import { object, shape } from "prop-types";
import get from "lodash/get";
import { LazyCollection, WithPreview, replaceAllStoriesInCollection, LazyLoadImages } from "@quintype/components";

import { getCollectionTemplate } from "../get-collection-template";
import PaymentSuccessful from "../molecules/payment-successful";
import PopupModal from "../atoms/popup-modal";
import { QuintTopResponsiveContainer } from "../rows/ad-free";
import { readCookie, eraseCookie } from "../../../isomorphic/components/helper/cookies";
import { addGTMPageVariables } from "../utils/utils";
import LatestNews from "../rows/latest-news";

export const HomePage = (props) => {
  const [showSucessPopup, setShowSucessPopup] = useState(false);

  const publisherName = get(props, ["config", "publisher-attributes", "name"], "quint");

  function scrollToElement(node) {
    const scrollOptions = {
      block: "start",
      behavior: "smooth",
    };
    node.scrollIntoView(scrollOptions);
  }

  useEffect(() => {
    if (readCookie("status") === "success") {
      eraseCookie("status");
      setShowSucessPopup(true);
    }

    addGTMPageVariables(null, "WEB", null, "HOME");

    let timer1, timer2, timer3, timer;
    const nodeNumber = window.sessionStorage.getItem("clicked_node");
    if (nodeNumber !== null && global.width >= 768) {
      const nodeAttribute = `div[data-infinite-scroll='${nodeNumber}']`;
      const targetNode = document.querySelector(nodeAttribute);
      scrollToElement(targetNode); // Scroll to the component

      /**
       * After scrolled, wait for the browser to figure out where the component(i.e, Sections/Collections on HomePage)
       * is after lazy loading is done. Then Scroll again.
       */
      if (nodeNumber > 2) {
        // 2 Sections are loaded initially on HomePage, Rest will lazyload
        timer = setTimeout(() => {
          scrollToElement(targetNode);
          timer1 = setTimeout(() => {
            scrollToElement(targetNode);
            scrollToElement(targetNode);
            timer2 = setTimeout(() => {
              scrollToElement(targetNode);
              scrollToElement(targetNode);
              scrollToElement(targetNode);
            }, 1000);
            timer3 = setTimeout(() => {
              scrollToElement(targetNode);
              scrollToElement(targetNode);
              scrollToElement(targetNode);
              scrollToElement(targetNode);
            }, 500);
          }, 500);
        }, 1000);
      }
      /* End */
    }

    return () => {
      clearInterval(timer);
      clearInterval(timer1);
      clearInterval(timer2);
      clearInterval(timer3);
    };
  }, []);

  // Page will refresh after 3 min of no scrolling or clicking.//
  // useEffect(() => {
  //   let timer = setTimeout(() => window.location.reload(), 3 * 60 * 1000);
  //   const handleActivity = () => {
  //     clearTimeout(timer);
  //     timer = setTimeout(() => window.location.reload(), 3 * 60 * 1000);
  //   };
  //   window.addEventListener("scroll", throttle(handleActivity, 250)); // Will trigger Event Listener 4 times in a sec.
  //   window.addEventListener("click", handleActivity);
  //   return () => {
  //     clearTimeout(timer);
  //     window.removeEventListener("scroll", handleActivity);
  //     window.removeEventListener("click", handleActivity);
  //   };
  // }, []);

  const collection1 = {
    ...props.data.collection,
    items: [
      {
        ...props.data.collection.items[0],
        latestNews: props.data.latestNewsCollection,
      },
    ],
  };

  const collection2 = { ...props.data.collection };
  collection2.items = props.data.collection.items.slice(1);

  return (
    <div>
      <QuintTopResponsiveContainer mobile="topAd" desktop="topAd" />
      {showSucessPopup ? (
        <PopupModal closePopup={() => setShowSucessPopup(false)}>
          <PaymentSuccessful />
        </PopupModal>
      ) : null}
      {publisherName !== "fit" ? (
        <LazyLoadImages>
          <LazyCollection collection={collection1} collectionTemplates={getCollectionTemplate} lazyAfter={2} />
          <LatestNews collection={props.data.latestNewsCollection} index={2} className="mobile-hide" />
          <LazyCollection collection={collection2} collectionTemplates={getCollectionTemplate} lazyAfter={2} />
        </LazyLoadImages>
      ) : (
        <LazyLoadImages>
          <LazyCollection
            collection={props.data.collection}
            collectionTemplates={getCollectionTemplate}
            lazyAfter={2}
          />
        </LazyLoadImages>
      )}
    </div>
  );
};

HomePage.propTypes = {
  data: shape({
    collection: object,
  }),
};

export const HomePagePreview = WithPreview(HomePage, (data, story) =>
  Object.assign({}, data, {
    collection: replaceAllStoriesInCollection(data.collection, story),
  })
);
